import {
  GET_ALL_FEATURES_SUCCESS,
  GET_ALL_MACHINE_FEATURE_SUCCESS,
} from "../actions/machine-action-types";

const initialState = {
  allMachineFeatureMapping: [],
  allFeatures: [],
};
export default function machine(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_MACHINE_FEATURE_SUCCESS:
      return {
        ...state,
        allMachineFeatureMapping: payload,
      };
    case GET_ALL_FEATURES_SUCCESS:
      return {
        ...state,
        allFeatures: payload,
      };
    default: {
      return state;
    }
  }
}
